import ToggleSelect from 'components/forms/ToggleSelect';
import PropTypes from 'prop-types';
import React from 'react';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {balanceColumns} from 'helpers/fieldHelpers';
import {seasonTypes, chemicalBaseTypes, systemTypes, countries} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class SpecialEvents extends React.Component {
  static propTypes = {
    analysis: PropTypes.object.isRequired,
    branch: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
    dataChanged: PropTypes.func.isRequired,
    edit: PropTypes.bool.isRequired,
    isType: PropTypes.func.isRequired,
    pool: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    products: PropTypes.array.isRequired,
  };

  getToggleEvents = () => {
    let {analysis, branch, products, pool, dealer} = this.props;
    const naturalChemistryEnabled = !!branch && !!branch.naturalChemistry;
    let {formatMessage} = this.props.intl;
    let all = [];

    // Warden IDs
    let severeWeatherOptions = {
      US: {
        keys: [223, 63, 205],
        labels: ['Pool Complete® 911', 'Pool Tonic', 'Pool First Aid™'],
      },
      CA: {
        keys: [223, 205],
        labels: ['Pool Complete® 911', 'Pool First Aid™'],
      },
    };

    let prePartyOptions = {
      US: {
        keys: [223, 63, 205],
        labels: ['Pool Complete® 911', 'Pool Tonic', 'Pool First Aid™'],
      },
      CA: {
        keys: [223, 205],
        labels: ['Pool Complete® 911', 'Pool First Aid™'],
      },
    };

    let postPartyOptions = {
      US: {
        keys: [223, 63, 205],
        labels: ['Pool Complete® 911', 'Pool Tonic', 'Pool First Aid™'],
      },
      CA: {
        keys: [223, 205],
        labels: ['Pool Complete® 911', 'Pool First Aid™'],
      },
    };

    severeWeatherOptions = severeWeatherOptions[dealer.country || countries.US];
    prePartyOptions = prePartyOptions[dealer.country || countries.US];
    postPartyOptions = postPartyOptions[dealer.country || countries.US];

    if (!naturalChemistryEnabled) {
      // Remove "Pool First Aid" if NC products not activated
      severeWeatherOptions.labels.pop();
      severeWeatherOptions.keys.pop();
      prePartyOptions.labels.pop();
      prePartyOptions.keys.pop();
      postPartyOptions.labels.pop();
      postPartyOptions.keys.pop();
    }

    const currentMaintenanceClarifier = products.find(p => p && p.id === pool.maintClarifier);

    if (!!currentMaintenanceClarifier && !!currentMaintenanceClarifier.wardenID && !prePartyOptions.keys.includes(currentMaintenanceClarifier.wardenID)) {
      //Pull Maintenance Clarifier from Product Profile if 'None' default to 'Pool Tonic' as Pre-party product
      prePartyOptions.keys.unshift(currentMaintenanceClarifier.wardenID);
      prePartyOptions.labels.unshift(currentMaintenanceClarifier.name);
    }

    all.push(
      <ToggleSelect
        label={formatMessage({id: 'customer.events.severe-weather'})}
        subLabel={formatMessage({id: 'general.severe-weather.product'})}
        dataKey="severeWeatherProduct"
        key="severeWeatherProduct"
        value={analysis.severeWeatherProduct}
        onChange={this.props.dataChanged}
        options={severeWeatherOptions.labels}
        keys={severeWeatherOptions.keys}
      />
    );

    all.push(
      <ToggleSelect
        label={formatMessage({id: 'customer.events.pre-party'})}
        subLabel={formatMessage({id: 'general.pre-party.product'})}
        dataKey="prePartyProduct"
        key="prePartyProduct"
        value={analysis.prePartyProduct}
        onChange={this.props.dataChanged}
        options={prePartyOptions.labels}
        keys={prePartyOptions.keys}
      />
    );

    all.push(
      <ToggleSelect
        label={formatMessage({id: 'customer.events.post-party'})}
        subLabel={formatMessage({id: 'general.post-party.product'})}
        dataKey="postPartyProduct"
        key="postPartyProduct"
        value={analysis.postPartyProduct}
        onChange={this.props.dataChanged}
        options={postPartyOptions.labels}
        keys={postPartyOptions.keys}
      />
    );

    return balanceColumns(all, 3);
  };

  render() {
    const {isType, analysis, pool} = this.props;
    const {formatMessage} = this.props.intl;

    if (
      analysis.season === seasonTypes.closing ||
      analysis.season === seasonTypes.outSeason ||
      pool.typeID !== systemTypes.pool ||
      !isType([
        chemicalBaseTypes.chlorinePool,
        chemicalBaseTypes.brominePool,
        chemicalBaseTypes.saltWaterPool,
        chemicalBaseTypes.mineralSpringsPool,
        chemicalBaseTypes.softswimPool,
        chemicalBaseTypes.synergyPool,
      ])
    ) {
      return null;
    }
    return (
      <div className="row">
        <div className="col-xs-12">
          <h2>
            <FormattedMessage id="general.water.events" />
            <ToolTip title={formatMessage({id: 'scan.select.customer'})} position={tooltipPositions.topRight} iconOnly />
          </h2>
          <div className="analysis-body">
            <div>{this.getToggleEvents()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SpecialEvents);
